import { FC } from 'react'
import { ReCaptchaProvider } from 'next-recaptcha-v3'
import Page from '@/client/submodules/Page'
import { ContactForm } from './ContactForm'
import { Featured } from './Featured'
import { ContactProps } from './types'

export const Contact: FC<ContactProps> = ({ seo, content, header, footer }) => {
  const { breadcrumb, heading, long_text, contact_form, side_square_box, image, asserts, result } = content

  return (
    <ReCaptchaProvider
      strategy='lazyOnload'
      defer
      async
      language='en'
      useEnterprise
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_KEY}
    >
      <Page seo={seo} header={header} footer={footer}>
        <Featured breadcrumb={breadcrumb} heading={heading} long_text={long_text} />
        <ContactForm
          contact_form={contact_form}
          side_square_box={side_square_box}
          image={image}
          asserts={asserts}
          result={result}
        />
      </Page>
    </ReCaptchaProvider>
  )
}
